import { axiosInstance } from "../../../axios/axiosInstance";

const API_REVIEWS_URL = "admin/reviews";
const API_SERVICE_PROVIDER_REVIEWS_URL = "organization/orders/reviews";
const API_GET_REVIEWS_MODULE_LIST_URL = API_REVIEWS_URL + "/list";
const API_GET_SERVICE_PROVIDER_REVIEWS_MODULE_LIST_URL =
  API_SERVICE_PROVIDER_REVIEWS_URL;
const API_GET_REVIEW_BY_ID_URL = API_REVIEWS_URL + "/view";
const API_SUPER_ADMIN_REVIEW_URL = API_REVIEWS_URL + "/review";

const API_SEND_SERVICE_PROVIDER_REVIEWS_URL = "organization/orders/review";

export const getReviews = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_GET_REVIEWS_MODULE_LIST_URL}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`
  );
};

export const getServiceProviderReviews = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_GET_SERVICE_PROVIDER_REVIEWS_MODULE_LIST_URL}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${
      dataToBeSent?.search || ""
    }&filters[service_provider_id]=${dataToBeSent?.service_provider_id || ""}`
  );
};

export const getReviewById = (dataToBeSent) => {
  return axiosInstance.get(
    API_GET_REVIEW_BY_ID_URL + "/" + dataToBeSent?.selectedReviewId
  );
};

// export const getReviewByProviderId = (dataToBeSent) => {
//   return axiosInstance.get(
//     API_GET_REVIEW_BY_PROVIDER_ID_URL + "/" + dataToBeSent?.selectedReviewId
//   );
// };

export const addSuperAdminReview = ({ selectedReviewId, ...rest }) => {
  return axiosInstance.post(
    API_SUPER_ADMIN_REVIEW_URL + "/" + selectedReviewId,
    rest
  );
};

export const addProviderAdminReview = ({ reviewId, ...rest }) => {
  return axiosInstance.post(
    API_SEND_SERVICE_PROVIDER_REVIEWS_URL + "/" + reviewId,
    rest
  );
};
